import { Button, colors, StapleTableRow } from '@insurancemenu/imenu-components-lib';
import React from 'react';
import { ReplicatedCustomInfo } from 'types/formService';
import { Delete, Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import InfoCardTableCell from '../InfoCardTableCell';
import { ReplicatedInfoTableColumn } from '..';
import { ButtonsWrapperStyled } from './styles';

interface Props {
  item: ReplicatedCustomInfo;
  columns: ReplicatedInfoTableColumn[];
  onEdit: (item: ReplicatedCustomInfo) => void;
  onDelete: (id: string) => void;
}

const InfoCardTableRow: React.FC<Props> = ({ item, columns, onEdit, onDelete }) => {
  const onEditItem = (): void => {
    onEdit(item);
  };

  const onDeleteItem = (): void => {
    onDelete(item.id);
  };

  return (
    <StapleTableRow>
      {columns.map((col, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <InfoCardTableCell key={`cell-${index}`} width={col.width} data={col.getValue(item)} />
      ))}
      <InfoCardTableCell
        width="6rem"
        customLayout={
          <ButtonsWrapperStyled>
            <Button type="icon" color="primary" onClick={onEditItem}>
              <Edit width="2.4rem" height="2.4rem" />
            </Button>
            <Button type="icon" color="custom" customColor={colors.red[600]} onClick={onDeleteItem}>
              <Delete width="2.4rem" height="2.4rem" />
            </Button>
          </ButtonsWrapperStyled>
        }
      />
    </StapleTableRow>
  );
};

export default InfoCardTableRow;
